import { Injectable } from '@angular/core';
import { MigrationService } from './migration.service';

@Injectable({
    providedIn: 'root'
})
export class AppInitializerService {

    constructor(private migrationService: MigrationService) { }

    async initialize(): Promise<void> {
        try {
            // Executa a migração se necessário
            if (this.migrationService.shouldRunMigration()) {
                await this.migrationService.migrateFromLocalStorageToIndexedDB();
            }
        } catch (error) {
            console.error('Erro na inicialização da aplicação:', error);
        }
    }
}
